// Ported from client/src/features/livechat/lib/socketClient.js — only the
// origin-resolution piece, not the JWT-authenticated getSocket()/singleton
// (that one's for the seller-portal's own logged-in dashboard, irrelevant
// here). This storefront's tracking page connects to the same public,
// unauthenticated /public-tracking namespace the seller-portal's own
// PublicOrderTrackingPage uses — see PublicOrderTrackingPage.jsx here.
const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:9000";

// Socket.io treats any path in the URL as a namespace, so an API base like
// "https://example.com/api" would try to join namespace "/api" and fail.
// Always connect to the bare origin — the backend serves socket.io at
// /socket.io regardless of where /api is mounted.
export function getSocketOrigin() {
  try {
    return new URL(API_BASE).origin;
  } catch {
    return API_BASE;
  }
}
